'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dCredentials$002dView$0024$0024anon$002471 from "./presto.-Credentials-View$$anon$71.js";
import * as $j_presto$002etypes$0024$002dCredential$002dUsage$002dUser$0024 from "./presto.types$-Credential-Usage-User$.js";
import * as $j_presto$002etypes$0024$002dUser$002dName$0024 from "./presto.types$-User-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialsView$$anon$70() {
  this.aIn = null;
  this.aIf = null;
  this.aIg = false;
  this.aIo = null;
  this.aIp = false;
  this.aIs = null;
  this.aIl = null;
  this.aIm = false;
  this.aIh = null;
  this.aIi = false;
  this.aIj = null;
  this.aIk = false;
  this.aIq = false;
  this.aIr = false;
  this.aIn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aIs = "CredentialUsageUser";
}
export { $c_Lpresto_CredentialsView$$anon$70 as $c_Lpresto_CredentialsView$$anon$70 };
$p = $c_Lpresto_CredentialsView$$anon$70.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialsView$$anon$70;
/** @constructor */
function $h_Lpresto_CredentialsView$$anon$70() {
}
export { $h_Lpresto_CredentialsView$$anon$70 as $h_Lpresto_CredentialsView$$anon$70 };
$h_Lpresto_CredentialsView$$anon$70.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aIn;
});
$p.M = (function() {
  if ((!this.aIg)) {
    this.aIf = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aIg = true;
  }
  return this.aIf;
});
$p.O = (function() {
  if ((!this.aIp)) {
    this.aIo = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aIp = true;
  }
  return this.aIo;
});
$p.E = (function() {
  return this.aIs;
});
$p.t = (function() {
  if ((!this.aIm)) {
    this.aIl = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aIm = true;
  }
  return this.aIl;
});
$p.N = (function() {
  if ((!this.aIi)) {
    this.aIh = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dUser$002dName$0024.$m_Lpresto_types$UserName$().cHi(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.aIi = true;
  }
  return this.aIh;
});
$p.Q = (function() {
  if ((!this.aIk)) {
    this.aIj = new $j_presto$002e$002dCredentials$002dView$0024$0024anon$002471.$c_Lpresto_CredentialsView$$anon$71();
    this.aIk = true;
  }
  return this.aIj;
});
$p.v = (function() {
  if ((!this.aIr)) {
    this.aIq = false;
    this.aIr = true;
  }
  return this.aIq;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee203) => ((p) => \u03b4scrutinee203.cFM(p)))($j_presto$002etypes$0024$002dCredential$002dUsage$002dUser$0024.$m_Lpresto_types$CredentialUsageUser$())));
});
var $d_Lpresto_CredentialsView$$anon$70 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialsView$$anon$70, "presto.CredentialsView$$anon$70", ({
  Gz: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_CredentialsView$$anon$70 as $d_Lpresto_CredentialsView$$anon$70 };
//# sourceMappingURL=presto.-Credentials-View$$anon$70.js.map
